module.exports = __webpack_public_path__ + "static/img/controlicon.663513a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/controlicon.png
// module id = 143
// module chunks = 1